import React from 'react';
import axios from 'axios';
const config = require('../../config').get(process.env.REACT_APP_ENVIRONMENT);

const Logout = (props) => {

  axios.get(`${config.URL}/api/management/logout`, {withCredentials: true, credentials: 'include'})
    .then(request => {
        props.history.push('/')
    })

  return (
    <div className="logout-dev">
      <h1>Bye</h1>
    </div>
  )
}

export default Logout